import { render } from "./BankingSecurity.vue?vue&type=template&id=56fe4d8b"
import script from "./BankingSecurity.vue?vue&type=script&lang=js"
export * from "./BankingSecurity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__